var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen24 = function SvgPen24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.207 2.793a3.121 3.121 0 0 0-4.414 0l-9.108 9.108a3 3 0 0 0-.79 1.394l-.865 3.463a1 1 0 0 0 1.213 1.212l3.462-.865a2.999 2.999 0 0 0 1.394-.79l9.108-9.108a3.121 3.121 0 0 0 0-4.414Zm-3 1.414a1.121 1.121 0 0 1 1.586 1.586l-9.108 9.108a1 1 0 0 1-.465.263l-1.846.462.462-1.846a1 1 0 0 1 .263-.464l9.108-9.109Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z",
    fill: "currentColor"
  })));
};
export default SvgPen24;